import { FC } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface ResourceChangeValueProps {
    strikethrough?: boolean;
    tone?: 'added' | 'neutral' | 'removed';
    value: string;
}

/** Shared, text-only value styling for historical snapshots and inline change review. */
const ResourceChangeValue: FC<ResourceChangeValueProps> = ({ strikethrough = false, tone = 'neutral', value }) => {
    const { token } = useAntDesignTheme();
    const highlighted = tone !== 'neutral';
    const Element = strikethrough ? 'del' : 'span';

    return (
        <Element
            style={{
                display: highlighted ? 'inline-flex' : 'block',
                alignItems: highlighted ? 'center' : undefined,
                boxSizing: 'border-box',
                minWidth: 0,
                maxWidth: '100%',
                margin: 0,
                padding: highlighted ? '0.25rem 0.5rem' : 0,
                borderRadius: highlighted ? token.borderRadius : 0,
                backgroundColor:
                    tone === 'added' ? token.colorPrimaryBg : tone === 'removed' ? token.colorFillSecondary : undefined,
                color: tone === 'added' ? token.colorPrimaryText : token.colorTextSecondary,
                fontFamily: value.includes('\n') ? token.fontFamilyCode : undefined,
                fontSize: value.includes('\n') ? token.fontSizeSM : undefined,
                whiteSpace: 'pre-wrap',
                overflowWrap: 'anywhere',
            }}
        >
            {value}
        </Element>
    );
};

export default ResourceChangeValue;
